/**
 * SVG path data for the play/pause morph icon. ViewBox: 0 0 100 100.
 *
 * Both paths share identical command structure (M L L L L Z × 2).
 * Coordinates are extracted as flat number arrays for JS-driven interpolation
 * (cross-browser, since CSS `d` transitions are Safari-unsupported).
 * Rounded corners via strokeLinejoin/strokeLinecap="round".
 */

/** Flat coordinate arrays — one entry per number in the path, in order. */
export const PLAY_COORDS = [32,22, 32,22, 72,50, 72,50, 32,78,  32,22, 32,22, 72,50, 72,50, 32,78];
export const PAUSE_COORDS = [27,22, 37,22, 37,22, 37,78, 27,78,  63,22, 73,22, 73,22, 73,78, 63,78];

/** Reconstruct the `d` string from a flat coordinate array. */
export const coordsToPath = (c: number[]): string =>
  `M ${c[0]} ${c[1]} L ${c[2]} ${c[3]} L ${c[4]} ${c[5]} L ${c[6]} ${c[7]} L ${c[8]} ${c[9]} Z ` +
  `M ${c[10]} ${c[11]} L ${c[12]} ${c[13]} L ${c[14]} ${c[15]} L ${c[16]} ${c[17]} L ${c[18]} ${c[19]} Z`;
